import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';

const AppMenuItem = ({ iconClass, type, path, exactMatch, children: links, name, roleType, roles, collapsed }) => {
  const { pathname } = useLocation();

  const isActive = useMemo(
    () => (linkPath, exact) => {
      if (exact) return pathname === linkPath;
      return pathname === linkPath || pathname.startsWith(linkPath + '/');
    },
    [pathname]
  );

  const isRoleAllowed = (allowedRoles) => (allowedRoles || []).includes(roleType);

  if (type === 'dropdown') {
    if (!isRoleAllowed(roles)) return null;
    const visibleChildren = (links || []).filter((link) => isRoleAllowed(link.roles));
    if (visibleChildren.length === 0) return null;

    if (collapsed) {
      return (
        <>
          {visibleChildren.map((link, i) => (
            <li key={i} className={`app-nav-item ${isActive(link.path, link.exactMatch) ? 'active' : ''}`}>
              <Link
                to={link.path}
                className={`app-nav-link ${isActive(link.path, link.exactMatch) ? 'active' : ''}`}
                title={link.name}
              >
                {link.icon ? (
                  <img src={link.icon} className="app-nav-child-img" alt="" />
                ) : link.iconClass ? (
                  <i className={`${link.iconClass} app-nav-icon`} />
                ) : null}
              </Link>
            </li>
          ))}
        </>
      );
    }

    return (
      <>
        <li className="app-nav-section-heading">
          <span>{name}</span>
        </li>
        {visibleChildren.map((link, i) => (
          <li key={i} className={`app-nav-item ${isActive(link.path, link.exactMatch) ? 'active' : ''}`}>
            <Link
              to={link.path}
              className={`app-nav-link app-nav-link--child ${isActive(link.path, link.exactMatch) ? 'active' : ''}`}
            >
              {link.icon ? (
                <img src={link.icon} className="app-nav-child-img" alt="" />
              ) : link.iconClass ? (
                <i className={`${link.iconClass} app-nav-child-icon`} />
              ) : null}
              <span className="app-nav-label">{link.name}</span>
            </Link>
          </li>
        ))}
      </>
    );
  }

  if (!isRoleAllowed(roles)) return null;

  return (
    <li className={`app-nav-item ${isActive(path, exactMatch) ? 'active' : ''}`}>
      <Link
        to={path}
        className={`app-nav-link ${isActive(path, exactMatch) ? 'active' : ''}`}
        title={collapsed ? name : ''}
      >
        {iconClass && <i className={`${iconClass} app-nav-icon`} />}
        {!collapsed && <span className="app-nav-label">{name}</span>}
      </Link>
    </li>
  );
};

export default AppMenuItem;
